var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9083 5.78794C17.9083 7.35456 16.6878 8.62062 15.1758 8.62062C13.6639 8.62062 12.4434 7.35456 12.4434 5.78794V4.16666C12.4434 2.60004 13.6639 1.33398 15.1758 1.33398C16.6878 1.33398 17.9083 2.60004 17.9083 4.16666V5.78794V5.78794Z",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89035 6.34321C9.14795 6.34321 10.1674 5.32373 10.1674 4.06614C10.1674 2.80854 9.14795 1.78906 7.89035 1.78906C6.63276 1.78906 5.61328 2.80854 5.61328 4.06614C5.61328 5.32373 6.63276 6.34321 7.89035 6.34321Z",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93294 15.9064H2.51764C1.96204 15.9064 1.50662 15.4054 1.61592 14.8589C2.10777 12.345 4.32109 10.4414 6.98071 10.4414C7.73513 10.4414 8.45011 10.592 9.10088 10.8663",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1768 11.3535C11.5062 11.3535 8.464 14.0678 7.96304 17.6018C7.88106 18.1483 8.31826 18.6401 8.87387 18.6401H21.4797C22.0353 18.6401 22.4634 18.1483 22.3906 17.6018C21.8896 14.0678 18.8474 11.3535 15.1768 11.3535V11.3535Z",
    stroke: "#909090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.35b5707b9b3b969e04384fd3b1e464a5.svg";
export { ForwardRef as ReactComponent };